import { apiFetch } from "../helper/apiClient";

/** Resolve sticker Card.id → Product.id (public, no auth). */
export async function resolveCardProductId(cardId) {
  const res = await apiFetch(
    `products/card/${encodeURIComponent(cardId)}/`,
    { method: "GET" },
    { auth: false }
  );

  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    return null;
  }
  return body.product_id ?? null;
}
